/**
 * @file 点赞
 * @author liudy
 */
import Api from '../../../path';
import { fetchData } from '@umu/umu-fetch';

export interface IInput {
    element_id: number;
    photo_id: string;
    like_type: 1; // 1点赞, 2点踩
    index: number;
}

export interface IOutput {
    like_result: number; // 1 点赞了； 3 取消点赞了
}

export const likePhoto = (data: IInput): Promise<IResponse<IOutput>> => {
    return fetchData(Api.PHOTO_LIKE_PHOTO, data).then((res: IResponse<IOutput>) => {
        return res;
    });
};
